import { createSlice } from '@reduxjs/toolkit';

function getToken() {
    const token = JSON.parse(localStorage.getItem('token'));
    return token;
}

const initialState = {
    token: getToken()
}

export const authSlice = createSlice({
    name: 'auth', 
    initialState,
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
            localStorage.setItem('token', JSON.stringify(action.payload));
        }
    }
})

export const { 
    setToken
} = authSlice.actions

export default authSlice.reducer